import { InjectionToken } from '@angular/core';
import { ActivityPlatformApiService } from './activity-platform-api.service';

export const HTTP_ACTIVITY_PLATFORM_SERVICE =
  new InjectionToken<ActivityPlatformApiService>('ActivityPlatformApiService');

export const ACTIVITY_PLATFORM_PROVIDER = {
  provide: HTTP_ACTIVITY_PLATFORM_SERVICE,
  useClass: ActivityPlatformApiService,
};
